import React from 'react';
import styled from "styled-components";
import { InlineIcon } from '@iconify/react';
import { Skeleton } from '@mui/material';
import { selectIsLoadingDashboard } from '@/store/reducers/dashboard/dashboard.selector';
import { ConnectedProps, connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

type TKpiCardProps = {
    icon?: string,
    title?: string,
    amount?: number,
    unit?: string,
    variant?: '1' | '2',
}

type PropsFromRedux = ConnectedProps<typeof connector>;

const KpiCardFct: React.FC<TKpiCardProps & PropsFromRedux> = ({
    icon = "fa-solid:users",
    title = "Nombre d'abonnés actifs",
    amount = 0,
    unit = "",
    variant = '1',
    loading,
}) => {

    const formatMillierNumber = (input : any) => {
        if(!input && input !== 0) return;

        var nombre = input;
        nombre += '';
        var sep = ' ';
        var reg = /(\d+)(\d{3})/;

        while (reg.test(nombre)) {
            nombre = nombre.replace(reg, '$1' + sep + '$2');
        }

        return nombre;
    }
    
    return (
        <KpiCardContainer var_test={variant}>
            <div className="general-container">
                <div className="icon-container" >
                    <InlineIcon icon={icon} className="users-ico"></InlineIcon>
                </div>
                <div className="text-container">
                    <div className="header-container">
                        {title}
                    </div>
                    {
                        loading &&
                        <Skeleton variant="text" animation="wave" className="sk-title" />
                    }
                    {
                        !loading &&
                        <div className="numbers-container">
                            {formatMillierNumber(amount)} <b>{unit}</b>
                        </div>
                    }

                </div>
            </div>
        </KpiCardContainer>
    )
}

const KpiCardContainer = styled.div<{ var_test: '1' | '2' }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    border-radius: 10px;

    .general-container{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 20px;
        width: 100%;
        height: 100%;
        padding: 10px;

        .icon-container{
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${({ var_test }) => {
        return var_test === '1' ? 'var(--ui-light)' : 'var(--ui-light)';
    }};
            height: 100%;
            aspect-ratio: 1;
            border-radius: 5px;

            .users-ico{
                transform: scale(1.5);
                color: var(--ui-medium);

            }
        }

        .text-container{
            display: flex;
            flex-direction: column;
            gap: 5px;
            height: 100%;

            .header-container{
                display: flex;
                align-items: center;
                font-size: var(--subtitle-size);
                color: var(--ui-medium) ;
                font-weight: 400;
                height: 50%;
                width: 100%;
            }

            .numbers-container{
                display: flex;
                align-items: center;
                height: 50%;
                width: 100%;
                color: var(--ui-dark) ;
                font-size: var(--title-size);
                font-weight: bold;

                b{
                        margin-left: 5px ;
                        font-weight: 600;
                        font-size: var(--subtitle-size);
                        transform: translateY(1px) ;
                }
            }
        }

    }
`;


const mapStateToProps = createStructuredSelector({
    loading: selectIsLoadingDashboard,
});


const connector = connect(mapStateToProps);
const KpiCard = connector(KpiCardFct);



export default KpiCard;